import { options } from "@modules/ReduxHook/constant";

export const defaultAction = (type, data, _options = {}) => {
  let payload = data == null ? null : data;
  return { type, payload, [options]: _options };
};
